import { Cart } from 'shared/types/cart';

export const calculateDiscountedAmount = (cart?: Partial<Cart>) => {
  return (
    (cart?.discountedAmount?.centAmount || 0) +
    (cart?.lineItems ?? []).reduce((acc, curr) => {
      if (curr.isGift) {
        return acc;
      }

      return acc + ((curr.price?.centAmount || 0) * (curr.count as number) - (curr.totalPrice?.centAmount || 0));
    }, 0)
  );
};
